import { Pipe, PipeTransform } from '@angular/core';
import { maskTypes } from '@core/utils/mask';

@Pipe({
  standalone: true,
  name: 'dynamicMask',
})
export class DynamicMaskPipe implements PipeTransform {
  transform(value: any, mask: maskTypes): string {    
    if (!mask) return value;

    let result = '';
    let valIndex = 0;

    if (mask === 'currency') {      
      let formattedValue = this.formatCurrency(String(value));
      return `RD$ ${formattedValue}`;
    }

    if (mask.includes('date') || mask.includes('datetime')) {
      let formattedValue = this.formatDate(
        value instanceof Date ? value : new Date(value),
        mask
      );
      return formattedValue;
    }

    value = String(value).replaceAll('-', '')

    for (let i = 0; i < mask.length && valIndex < value.length; i++) {
      result += mask[i] === '*' ? value[valIndex++] : mask[i];
    }

    return result;
  }

  private formatCurrency(value: string): string {
    const numericValue = value.replace(/[^0-9.]/g, '');
    
    const num = parseFloat(numericValue);
    if (isNaN(num)) return '0.00';
    return num.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  private formatDate(value: Date, mask: string): string {
    const [type, format] = mask.split('.');

    return value.toLocaleDateString(
      'en-US',
      format == 'string'
        ? {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: type == 'datetime' ? 'numeric' : undefined,
            minute: type == 'datetime' ? 'numeric' : undefined,
            second: type == 'datetime' ? 'numeric' : undefined,
          }
        : {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: type == 'datetime' ? 'numeric' : undefined,
            minute: type == 'datetime' ? 'numeric' : undefined,
            second: type == 'datetime' ? 'numeric' : undefined,
          }
    );
  }
}
